class Carousel {
  constructor(container, options = {}) {
    this.container = container;
    this.track = container.querySelector('.slideshow__slide-list');
    //console.log('Track:', this.track); // Log the track
    this.slides = Array.from(container.querySelectorAll('slide-show-item'));
    //console.log('Slides:', this.slides); // Log the slides
    //this.dotsContainer = container.querySelector('.slideshow__nav');
    // console.log('Dots Container:', this.dotsContainer);
    //this.dots = Array.from(this.dotsContainer.querySelectorAll('.slideshow__image-wrapper'));
    //console.log('Dots:', this.dots); // Log the dots
    this.currentIndex = 0;
    this.options = {
      autoplay: options.autoplay || false,
      autoplaySpeed: options.autoplayspeed || 3000,
      infinite: options.infinite || true,
      ...options,
    };

    this.init();
  }

  init() {
    this.setupSlides();
    //this.setupDots();
    this.setupAccessibility();
    this.setupAutoplay();
    this.setupTouchSupport();
  }

  setupSlides() {
    this.slideWidth = this.slides[0].getBoundingClientRect().width;
    this.track.style.width = `${this.slideWidth * this.slides.length}px`;
  }


 //setupDots() {
 //   this.dots.forEach((dot, index) => {
 //     dot.addEventListener('click', () => this.goToSlide(index));
 //   });
 //   this.updateDots();
 // }

  setupAutoplay() {
    // Enable autoplay if the option is set
    if (this.options.autoplay) {
      this.autoplayInterval = setInterval(() => this.nextSlide(), this.options.autoplaySpeed);
    }
  }

  setupAccessibility() {
    this.track.setAttribute('role', 'region');
    this.track.setAttribute('aria-label', 'Image Carousel');
    this.slides.forEach((slide, index) => {
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-label', `Slide ${index + 1}`);
    });
  }

  setupTouchSupport() {
    let startX = 0;
    let isDragging = false;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    this.track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const currentX = e.touches[0].clientX;
      const diff = startX - currentX;

      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
        isDragging = false;
      }
    });

    this.track.addEventListener('touchend', () => {
      isDragging = false;
    });
  }

  updateSlidePosition() {
    this.track.style.transform = `translateX(-${this.currentIndex * this.slideWidth}px)`;
  }

  //updateDots() {
    // Update the active state of the dots
  //  this.dots.forEach((dot, index) => {
  //    dot.setAttribute('aria-current', index === this.currentIndex);
  //  });
  //}
  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else if (this.options.infinite) {
      this.currentIndex = this.slides.length - 1;
    }
    this.updateSlidePosition();
   // this.updateDots();
  }

  nextSlide() {
    if (this.currentIndex < this.slides.length - 1) {
      this.currentIndex++;
    } else if (this.options.infinite) {
      this.currentIndex = 0;
    }
    this.updateSlidePosition();
    //this.updateDots();
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.updateSlidePosition();
    //this.updateDots();
  }
  updateSlidePosition() {
    // Move the track to the current slide
    this.track.style.transform = `translateX(-${this.currentIndex * this.slideWidth}px)`;
  }

  //updateDots() {
    // Update the active state of the dots
  //  this.dots.forEach((dot, index) => {
  //    dot.setAttribute('aria-current', index === this.currentIndex);
  //  });
  //}

  prevSlide() {
    // Move to the previous slide
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else if (this.options.infinite) {
      this.currentIndex = this.slides.length - 1;
    }
    this.updateSlidePosition();
    //this.updateDots();
  }

  nextSlide() {
    // Move to the next slide
    if (this.currentIndex < this.slides.length - 1) {
      this.currentIndex++;
    } else if (this.options.infinite) {
      this.currentIndex = 0;
    }
    this.updateSlidePosition();
    //this.updateDots();
  }

  goToSlide(index) {
    // Move to a specific slide
    this.currentIndex = index;
    this.updateSlidePosition();
    //this.updateDots();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const carouselElement = document.querySelector('slide-show'); // Use the class selector
  //console.log(carouselElement); // Should log the element or null
  if (carouselElement) {
    const carousel = new Carousel(carouselElement, {
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: true,
    });
  } else {
    console.error('Carousel element not found!');
  }
});